import '../styles/login.css';
import '../styles/register.css';
import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { auth } from "./firebase";
import { GoogleSignIn } from "./GoogleSignIn";

export const Register = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // Само пътища в сайта – иначе ?next= става пренасочване към чужд адрес.
  const next = /^\/(?!\/)/.test(params.get('next') || '') ? params.get('next') : null;
  const [errorMessage, setErrorMessage] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get('username');
    const email = formData.get('email');
    const password = formData.get('password');
    const repass = formData.get('repass');

    if (!name) { setErrorMessage("Моля, въведете потребителско име"); return; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) { setErrorMessage("Невалиден имейл адрес"); return; }
    if (password !== repass) { setErrorMessage("Паролите не съвпадат"); return; }
    if (password.length < 6) { setErrorMessage("Паролата трябва да е поне 6 символа"); return; }

    try {
      await auth.createUserWithEmailAndPassword(email, password);
      const currentUser = auth.currentUser;
      localStorage.setItem('username', name);
      await currentUser.updateProfile({ displayName: name });
      navigate(next || '/catalog');
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        setErrorMessage("Имейлът вече съществува");
      } else {
        setErrorMessage("Грешка при регистрация. Опитайте отново.");
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <h2>Stamsy Art</h2>
          <p>Ръчно рисувани дрехи и подаръци</p>
        </div>
        <h3 className="auth-title">Създайте акаунт</h3>
        {errorMessage && <div className="auth-error">{errorMessage}</div>}
        <GoogleSignIn onSignedIn={() => navigate(next || '/catalog')} />
        <div className="auth-or"><span>или</span></div>
        <form onSubmit={onSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="username">Потребителско име</label>
            <input
              type="text"
              id="username"
              name="username"
              placeholder="Вашето име"
              required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="email">Имейл</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="вашият@имейл.com"
              required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="password">Парола</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="repass">Повторете паролата</label>
            <input
              type="password"
              id="repass"
              name="repass"
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" className="auth-btn">Регистрирай се</button>
        </form>
        <p className="auth-switch">
          Вече имате акаунт? <Link to={next ? `/login?next=${encodeURIComponent(next)}` : "/login"}>Вход</Link>
        </p>
      </div>
    </div>
  );
};
